module.exports = __webpack_public_path__ + "assets/img/thumb-ARUMALABS-1-Video.70438ed5.jpg";